export enum ConsentGroupType {
    "Undefined",
    "Standard",
    "Important",
}

export interface IOnetConsentItem {
    id: string;
    shortDescription: string;
    longDescription: string;
    isRequired: boolean;
    isSelectable: boolean;
    isSelectedByDefault: boolean;
    consentGroupType: ConsentGroupType;
}

export interface IOnetConsentSaveInput {
    screenType: ConsentScreenType;
    consentId: string;
    isApproved: boolean;
}

export enum ConsentScreenType {
    Undefined = 0,
    LoginProcess = 1,
    RegistrationProcess = 2,
    LoyaltyProgram = 3,
    VasLoginProcess = 4,
    VasRegistrationProcess = 5,
    VasConfirmationProcess = 6,
    MgmRegistrationProcess = 7,
    UserProfile = 8,
    Onet = 9,
}
